/** Misma normalización que SearchableSelect / CatalogMultiPicker (sin tildes, case-insensitive). */
export function foldSearchText(value: string): string {
  return value.toLowerCase().normalize("NFD").replace(/\p{M}/gu, "");
}

export function foldedIncludes(haystack: string, needle: string): boolean {
  const q = needle.trim();
  if (!q) return true;
  return foldSearchText(haystack).includes(foldSearchText(q));
}
